import * as z from 'zod/mini'
import { keyedIssue, userFields } from '@seiri/shared/common'

/**
 * Choosing a new password: the API's strength rule, typed twice. Only `password` is sent
 * (`setNewPasswordBody`); the repeat is checked here, reported on `password2`.
 */
export const newPasswordFormModel = z.object({ password: userFields.newPassword, password2: z.string() }).check(
  z.superRefine((value, ctx) => {
    if (value.password2 !== value.password) {
      ctx.addIssue(keyedIssue('validation.passwordsMatch', ['password2']))
    }
  }),
)
export type NewPasswordFormModel = z.infer<typeof newPasswordFormModel>
